import { Navigate, Route, Routes } from 'react-router-dom';
import { OfflineBanner } from './components/OfflineBanner';
import { AppLayout } from './routes/AppLayout';
import { EditFlightPage } from './routes/EditFlightPage';
import { EventDetailPage } from './routes/EventDetailPage';
import { EventListPage } from './routes/EventListPage';
import { MembersPage } from './routes/MembersPage';
import { NewEventPage } from './routes/NewEventPage';
import { AdminAircraftPage } from './routes/admin/AdminAircraftPage';
import { AdminCsvImportPage } from './routes/admin/AdminCsvImportPage';
import { AdminDashboard } from './routes/admin/AdminDashboard';
import { AdminFlightsPage } from './routes/admin/AdminFlightsPage';
import { AdminInvitationsPage } from './routes/admin/AdminInvitationsPage';
import { AdminLayout } from './routes/admin/AdminLayout';
import { AdminSettingsPage } from './routes/admin/AdminSettingsPage';
import { AdminUsersPage } from './routes/admin/AdminUsersPage';
import { FlightDetailPage } from './routes/FlightDetailPage';
import { FlightListPage } from './routes/FlightListPage';
import { LoginPage } from './routes/LoginPage';
import { MyRequestsPage } from './routes/MyRequestsPage';
import { NewFlightPage } from './routes/NewFlightPage';
import { PasswordResetPage } from './routes/PasswordResetPage';
import { RegisterPage } from './routes/RegisterPage';
import { VerifyEmailPage } from './routes/VerifyEmailPage';
import { SettingsPage } from './routes/placeholders';

export function App() {
  return (
    <>
      <OfflineBanner />
      <Routes>
        <Route path="/" element={<Navigate to="/app/flights" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register/:token" element={<RegisterPage />} />
        <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />

        <Route path="/app" element={<AppLayout />}>
          <Route index element={<Navigate to="flights" replace />} />
          <Route path="flights" element={<FlightListPage />} />
          <Route path="flights/new" element={<NewFlightPage />} />
          <Route path="flights/:id" element={<FlightDetailPage />} />
          <Route path="flights/:id/edit" element={<EditFlightPage />} />
          <Route path="my-requests" element={<MyRequestsPage />} />
          <Route path="events" element={<EventListPage />} />
          <Route path="events/new" element={<NewEventPage />} />
          <Route path="events/:id" element={<EventDetailPage />} />
          <Route path="members" element={<MembersPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="users/import" element={<AdminCsvImportPage />} />
          <Route path="invitations" element={<AdminInvitationsPage />} />
          <Route path="aircraft" element={<AdminAircraftPage />} />
          <Route path="flights" element={<AdminFlightsPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
